import { Dropdown, Button } from "@endya-conformite/ui-kit";
import FilterIcon from "@endya-conformite/ui-kit/src/assets/icons/filter.svg?react";
import { Dispatch, ReactNode, SetStateAction, useState } from "react";
import styles from "./FilterDropdown.module.scss";

type FilterDropdownProps<T> = {
  activeCount: number;
  applied: T;
  onApply: (next: T) => void;
  className?: string;
  children: (draft: T, setDraft: Dispatch<SetStateAction<T>>) => ReactNode;
};

function FilterPanel<T>({
  applied,
  onApply,
  close,
  children,
}: {
  applied: T;
  onApply: (next: T) => void;
  close: () => void;
  children: (draft: T, setDraft: Dispatch<SetStateAction<T>>) => ReactNode;
}) {
  const [draft, setDraft] = useState<T>(applied);

  const handleApply = () => {
    onApply(draft);
    close();
  };

  return (
    <div className={styles.filters}>
      {children(draft, setDraft)}
      <div className={styles.footer}>
        <Button variant="text" onClick={handleApply}>
          Appliquer
        </Button>
      </div>
    </div>
  );
}

export function FilterDropdown<T>({
  activeCount,
  applied,
  onApply,
  className,
  children,
}: FilterDropdownProps<T>) {
  return (
    <Dropdown
      content={
        <div className={styles.buttonContent}>
          <p>Filtrer</p>
          {activeCount > 0 && `(${activeCount})`}
        </div>
      }
      variant="text"
      icon={<FilterIcon />}
      placement="bottom-end"
      className={className}
      dismissOnClick
    >
      {({ close }) => (
        <FilterPanel applied={applied} onApply={onApply} close={close}>
          {children}
        </FilterPanel>
      )}
    </Dropdown>
  );
}
